import React from 'react'

const RoleLabels: React.FC<{ labels: string[] }> = ({ labels }) => (
  <span style={{ display: 'inline', wordBreak: 'normal', overflowWrap: 'normal' }}>
    {labels.map((label, index) => (
      <React.Fragment key={`${label}-${index}`}>
        {index > 0 && ' '}
        <span style={{ display: 'inline-block', whiteSpace: 'nowrap' }}>
          {label}{index < labels.length - 1 ? ',' : ''}
        </span>
      </React.Fragment>
    ))}
  </span>
)

export default RoleLabels
